import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PremiumFeature, WineLabelCustomPictogramView } from '../../api';
import HeaderIcon from '../../assets/icons/sustainability-icon';
import CustomerContainer from '../../components/customer-container/customer-container';
import FlexBoxColumn from '../../components/flexbox/flex-box-column';
import FlexBox from '../../components/flexbox/flexbox';
import { SustainabilityPictograms } from '../../constants/pictograms';
import { PictogramId } from '../../models/pictogram';
import DetailedSustainability from './detailed-sustainability';
import Pictogram from './pictogram';
import { getColors } from './winefo-point-utils';

interface SustainabilityProps {
  defaultPictogramIds?: PictogramId[];
  customPictograms?: WineLabelCustomPictogramView[];
  detailedPictogramIds: PictogramId[];
  ppwrId?: string;
  premiumFeature?: PremiumFeature;
}

const Sustainability = ({
  defaultPictogramIds,
  customPictograms,
  detailedPictogramIds,
  ppwrId,
  premiumFeature,
}: SustainabilityProps) => {
  const { t } = useTranslation();
  const defaultPictograms = SustainabilityPictograms.filter((it) =>
    defaultPictogramIds?.includes(it.id)
  );
  const hasDefaultPictogram = defaultPictograms.length > 0;
  const hasCustomPictogram = customPictograms && customPictograms.length > 0;
  const hasDetailedPictogram = detailedPictogramIds.length > 0;
  const hasPictogramImage = hasDefaultPictogram || hasCustomPictogram;
  const hasContent = hasPictogramImage || hasDetailedPictogram || !!ppwrId;
  const colors = getColors(premiumFeature);

  return hasContent ? (
    <CustomerContainer
      title={t('pictograms.sustainability-title')}
      icon={<HeaderIcon />}
      colors={colors}
    >
      {hasPictogramImage && (
        <FlexBox sx={{ p: 2, gap: 2, flexWrap: 'wrap' }}>
          {defaultPictograms.map((pictogram) => (
            <Pictogram key={pictogram.id} src={pictogram.src} />
          ))}
          {customPictograms?.map((pictogram) => (
            <Pictogram key={pictogram.id} src={pictogram.downloadUrl} />
          ))}
        </FlexBox>
      )}
      {ppwrId && (
        <>
          {hasPictogramImage && <Divider />}
          <FlexBoxColumn sx={{ p: 2, gap: 0.5 }}>
            <Typography fontFamily="inherit">
              {t('pictograms.ppwr-title')}
            </Typography>
            <Typography fontFamily="inherit">{ppwrId}</Typography>
          </FlexBoxColumn>
          {hasDetailedPictogram && <Divider />}
        </>
      )}
      <DetailedSustainability pictogramIds={detailedPictogramIds} />
    </CustomerContainer>
  ) : (
    <></>
  );
};

export default Sustainability;
